import {Route, Routes} from 'react-router-dom'
import {lazy, Suspense} from 'react'
import LoginLayout from '@/templates/LoginLayout.tsx'
import AdminLayout from '@/templates/AdminLayout.tsx'
import OperatorLayout from '@/templates/OperatorLayout.tsx'
import SystemAdminLayout from '@/templates/SystemAdminLayout.tsx'
import ProtectedRoute from '@/templates/ProtectedRoute.tsx'
import UsersPage from "@/pages/Admin/Catalogs/Users";
import RolesPage from "@/pages/Admin/Catalogs/Roles";
import ToolsPage from "@/pages/Admin/Tools";
import Login from "@/pages/Login/Login.tsx";
import SettlementsPage from "@/pages/Operator/Settlements";
import SettingsPage from "@/pages/SystemAdmin/Settings";
import {PersonEdit, PersonsPage} from "@/pages/Operator/Person";
import { CategoriesPage } from "@/pages/Operator/Category";
import { ContactLinkCategoriesPage } from "@/pages/Operator/ContactLinkCategory";
import {
  ModalContainer,
  ModalProvider,
  ToastContainerProvider
} from "@fs/uikit-react";

// Lazy-loaded pages
const NotFound = lazy(() => import('./pages/NotFound/NotFound.tsx'))

function App() {
  return (
    <ModalProvider>
      <ToastContainerProvider>
        <Suspense fallback={<div className="loading">Loading...</div>}>
          <Routes>
            {/* Public routes */}
          <Route path="/" element={<LoginLayout />}>
            <Route index element={<Login />} />
          </Route>

          {/* Admin routes */}
          <Route element={<ProtectedRoute requiredRole="admin" />}>
            <Route path="/admin" element={<AdminLayout />}>
              {/* Catalog routes */}
              <Route path="catalogs">
                <Route path="users" element={<UsersPage />} />
                <Route path="roles" element={<RolesPage />} />
              </Route>
              {/* Tools route */}
              <Route path="tools" element={<ToolsPage />} />
              {/* Other admin routes */}
              <Route path="users" element={<div>Users Management</div>} />
              <Route path="settings" element={<div>Admin Settings</div>} />
            </Route>
          </Route>


          {/* Operator routes */}
          <Route element={<ProtectedRoute requiredRole="operator" />}>
            <Route path="/operator" element={<OperatorLayout />}>
              <Route path="institutions" element={<div>Установи</div>} />
              <Route path="settlements" element={<SettlementsPage />} />
              <Route path="contact-link-categories" element={<ContactLinkCategoriesPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="person" element={<PersonsPage />} />
              <Route path="person/:id" element={<PersonEdit />} />
              <Route path="profile" element={<div>Operator Profile</div>} />
              <Route path="messages" element={<div>Operator Messages</div>} />
            </Route>
          </Route>

          {/* System Admin routes */}
          <Route element={<ProtectedRoute requiredRole="system_admin" />}>
            <Route path="/system-admin" element={<SystemAdminLayout />}>
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Route>

          {/* Catch all route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        <ModalContainer />
      </ToastContainerProvider>
    </ModalProvider>
  )
}

export default App
